import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DataTestTypeWithIconModule } from '../../data-test-type-with-icon/data-test-type-with-icon.module';
import { DataTestTypeCellRendererComponent } from './data-test-type-cell-renderer.component';

@NgModule({
  declarations: [DataTestTypeCellRendererComponent],
  imports: [CommonModule, FontAwesomeModule, DataTestTypeWithIconModule],
  exports: [DataTestTypeCellRendererComponent],
})
export class DataTestTypeCellRendererModule {}
